import React from "react";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="copyright">
        &copy; {currentYear} Moeez Abdul. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
